import { Box, SvgIcon, Typography } from '@mui/material';

export function ClockIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    width: 16,
    height: 16,
    color: 'rgba(24,87,76,0.48)',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...rest}
      sx={rootSx}
    >
      <path
        d="M12 4a8 8 0 108 8 8.009 8.009 0 00-8-8zm0 1.2A6.8 6.8 0 115.2 12 6.791 6.791 0 0112 5.2zm-.609 1.991a.6.6 0 00-.591.609v4.4a.6.6 0 00.176.424l2 2a.6.6 0 10.848-.848L12 11.952V7.8a.6.6 0 00-.609-.609z"
        transform="translate(-4 -4)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function FloatingAddIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    width: 95,
    height: 95,
    color: 'rgba(24,87,76,0.48)',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 95 95"
      {...rest}
    >
      <defs>
        <filter
          id="a"
          x={0}
          y={0}
          width={95}
          height={95}
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={7.5} result="blur" />
          <feFlood floodOpacity={0.078} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g data-name="Group 114364">
        <g
          transform="translate(23105.5 14402.5) translate(-23105.5 -14402.5)"
          filter="url(#a)"
        >
          <g
            data-name="Rectangle 55807"
            transform="translate(22.5 18.5)"
            fill="#fff"
            stroke="#007965"
            strokeWidth={6}
          >
            <rect width={50} height={50} rx={25} stroke="none" />
            <rect x={3} y={3} width={44} height={44} rx={22} fill="none" />
          </g>
        </g>
        <path
          d="M26.432 4a22.432 22.432 0 1022.431 22.432A22.457 22.457 0 0026.432 4zm9.533 24.114h-7.851v7.851a1.682 1.682 0 01-3.365 0v-7.851H16.9a1.682 1.682 0 010-3.365h7.851V16.9a1.682 1.682 0 013.365 0v7.851h7.851a1.682 1.682 0 010 3.365z"
          transform="translate(23105.5 14402.5) translate(-23084.432 -14385.432)"
          fill="#007965"
        />
      </g>
    </SvgIcon>
  );
}

export function ThreeDotsMenuIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    width: 3.111,
    height: 14,
    color: 'rgba(24,87,76,0.48)',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 3.111 14"
      {...rest}
      sx={rootSx}
    >
      <path
        id="icons8-menu-vertical"
        d="M21.556,16.889a1.556,1.556,0,1,0,1.556,1.556A1.556,1.556,0,0,0,21.556,16.889Zm0-5.444A1.556,1.556,0,1,0,23.111,13,1.556,1.556,0,0,0,21.556,11.444Zm0-5.444a1.556,1.556,0,1,0,1.556,1.556A1.556,1.556,0,0,0,21.556,6Z"
        transform="translate(-20 -6)"
        fill="#8c8a8d"
      />
    </SvgIcon>
  );
}
export function GlobeIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 14,
    width: 14,
    stroke: '#5C6266',
    strokeWidth: 0.2,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="14.2"
      height="14.2"
      viewBox="0 0 14.2 14.2"
      {...rest}
      sx={rootSx}
    >
      <path
        id="icons8-globe"
        d="M11,4a7,7,0,1,0,7,7A7.008,7.008,0,0,0,11,4Zm0,1.05a1.177,1.177,0,0,1,.8.37,3.877,3.877,0,0,1,.824,1.221A8.739,8.739,0,0,1,13.108,8.2H8.892a8.738,8.738,0,0,1,.481-1.559A3.878,3.878,0,0,1,10.2,5.42,1.177,1.177,0,0,1,11,5.05Zm-2.178.416a6.149,6.149,0,0,0-.4.737,9.652,9.652,0,0,0-.621,2H5.749A5.947,5.947,0,0,1,8.822,5.466Zm4.356,0A5.947,5.947,0,0,1,16.251,8.2H14.2a9.652,9.652,0,0,0-.621-2A6.149,6.149,0,0,0,13.178,5.466ZM5.312,9.25H7.661A13.558,13.558,0,0,0,7.5,11a13.558,13.558,0,0,0,.161,1.75H5.312a5.979,5.979,0,0,1,0-3.5Zm3.4,0h4.573A12.4,12.4,0,0,1,13.45,11a12.4,12.4,0,0,1-.163,1.75H8.713A12.4,12.4,0,0,1,8.55,11,12.4,12.4,0,0,1,8.713,9.25Zm5.625,0h2.35a5.98,5.98,0,0,1,0,3.5h-2.35A13.558,13.558,0,0,0,14.5,11,13.558,13.558,0,0,0,14.339,9.25ZM5.749,13.8H7.8a9.652,9.652,0,0,0,.621,2,6.151,6.151,0,0,0,.4.737A5.947,5.947,0,0,1,5.749,13.8Zm3.144,0h4.215a8.739,8.739,0,0,1-.481,1.559A3.878,3.878,0,0,1,11.8,16.58a1.177,1.177,0,0,1-.8.37,1.177,1.177,0,0,1-.8-.37,3.878,3.878,0,0,1-.824-1.221A8.739,8.739,0,0,1,8.892,13.8Zm5.309,0h2.049a5.947,5.947,0,0,1-3.073,2.734,6.151,6.151,0,0,0,.4-.737A9.652,9.652,0,0,0,14.2,13.8Z"
        transform="translate(-3.9 -3.9)"
        fill="currentColor"
        stroke="#5c6266"
      />
    </SvgIcon>
  );
}

export function CertificateIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 12,
    width: 13,
    color: '#0F0B117A',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="13.364"
      height="12.696"
      viewBox="0 0 13.364 12.696"
      {...rest}
      sx={rootSx}
    >
      <path
        id="icons8-certificate"
        d="M5.838,7A1.841,1.841,0,0,0,4,8.838v6.348a1.841,1.841,0,0,0,1.838,1.838h5.847v-.561a3.274,3.274,0,0,1-.264-.441H5.838A.836.836,0,0,1,5,15.185V8.838A.836.836,0,0,1,5.838,8h9.689a.836.836,0,0,1,.835.835v2.238a3.7,3.7,0,0,1,1,.752V8.838A1.841,1.841,0,0,0,15.526,7ZM7.174,9.673a.5.5,0,1,0,0,1H14.19a.5.5,0,1,0,0-1Zm7.517,2a2.666,2.666,0,0,0-2,4.432v3.085a.5.5,0,0,0,.779.417l1.225-.817,1.225.817a.5.5,0,0,0,.779-.417V16.109a2.666,2.666,0,0,0-2-4.432Zm0,1a1.67,1.67,0,1,1-1.67,1.67A1.663,1.663,0,0,1,14.691,12.68Zm-7.517.668a.5.5,0,1,0,0,1h3.007a.5.5,0,1,0,0-1Zm6.515,3.477a2.639,2.639,0,0,0,2,0v1.433l-.724-.483a.5.5,0,0,0-.556,0l-.724.483Z"
        transform="translate(-4 -7)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function HospitalIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 12,
    width: 13,
    color: '#0F0B117A',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="13.364"
      height="14"
      viewBox="0 0 13.364 14"
      {...rest}
      sx={rootSx}
    >
      <path
        id="icons8-hospital-3"
        d="M8.568,2a1.757,1.757,0,0,0-1.75,1.75v.8H4.75A1.757,1.757,0,0,0,3,6.3V14.25A1.757,1.757,0,0,0,4.75,16H8.568a.477.477,0,0,0,.477-.477V13.136h1.273v2.386A.477.477,0,0,0,10.8,16h3.818a1.757,1.757,0,0,0,1.75-1.75V6.3a1.757,1.757,0,0,0-1.75-1.75H12.545v-.8A1.757,1.757,0,0,0,10.8,2Zm0,.955H10.8a.788.788,0,0,1,.8.8V5.977a.788.788,0,0,1-.8.8H8.568a.788.788,0,0,1-.8-.8V3.75A.788.788,0,0,1,8.568,2.955Zm1.106.63a.477.477,0,0,0-.47.484v.318H8.886a.477.477,0,1,0,0,.955H9.2v.318a.477.477,0,1,0,.955,0V5.341h.318a.477.477,0,1,0,0-.955h-.318V4.068a.477.477,0,0,0-.485-.484ZM4.75,5.5H6.818v.477a1.757,1.757,0,0,0,1.75,1.75H10.8a1.757,1.757,0,0,0,1.75-1.75V5.5h2.068a.788.788,0,0,1,.8.8V14.25a.788.788,0,0,1-.8.8H11.273V12.977a.8.8,0,0,0-.8-.8H8.886a.8.8,0,0,0-.8.8v2.068H4.75a.788.788,0,0,1-.8-.8V6.3A.788.788,0,0,1,4.75,5.5Zm.8,2.864a.318.318,0,0,0-.318.318v.636a.318.318,0,0,0,.318.318h.636A.318.318,0,0,0,6.5,9.318V8.682a.318.318,0,0,0-.318-.318Zm2.545,0a.318.318,0,0,0-.318.318v.636a.318.318,0,0,0,.318.318h.636a.318.318,0,0,0,.318-.318V8.682a.318.318,0,0,0-.318-.318Zm2.545,0a.318.318,0,0,0-.318.318v.636a.318.318,0,0,0,.318.318h.636a.318.318,0,0,0,.318-.318V8.682a.318.318,0,0,0-.318-.318Zm2.545,0a.318.318,0,0,0-.318.318v.636a.318.318,0,0,0,.318.318h.636a.318.318,0,0,0,.318-.318V8.682a.318.318,0,0,0-.318-.318ZM5.545,10.273a.318.318,0,0,0-.318.318v.636a.318.318,0,0,0,.318.318h.636a.318.318,0,0,0,.318-.318v-.636a.318.318,0,0,0-.318-.318Zm2.545,0a.318.318,0,0,0-.318.318v.636a.318.318,0,0,0,.318.318h.636a.318.318,0,0,0,.318-.318v-.636a.318.318,0,0,0-.318-.318Zm2.545,0a.318.318,0,0,0-.318.318v.636a.318.318,0,0,0,.318.318h.636a.318.318,0,0,0,.318-.318v-.636a.318.318,0,0,0-.318-.318Zm2.545,0a.318.318,0,0,0-.318.318v.636a.318.318,0,0,0,.318.318h.636a.318.318,0,0,0,.318-.318v-.636a.318.318,0,0,0-.318-.318ZM5.545,12.182a.318.318,0,0,0-.318.318v.636a.318.318,0,0,0,.318.318h.636a.318.318,0,0,0,.318-.318V12.5a.318.318,0,0,0-.318-.318Zm7.636,0a.318.318,0,0,0-.318.318v.636a.318.318,0,0,0,.318.318h.636a.318.318,0,0,0,.318-.318V12.5a.318.318,0,0,0-.318-.318Z"
        transform="translate(-3 -2)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function AppointmentIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    width: 44,
    height: 44,
    color: '#007965',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 44 44"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 5629">
        <g data-name="Group 5766" transform="translate(-29 -331)">
          <rect
            data-name="Rectangle 44708"
            width={44}
            height={44}
            rx={6}
            transform="translate(29 331)"
            fill="#fff6f0"
          />
          <path
            d="M6.571 0a6.571 6.571 0 106.571 6.571A6.584 6.584 0 006.571 0zm0 1.714a4.857 4.857 0 11-4.857 4.857 4.844 4.844 0 014.857-4.857zm-.013 1.131a.857.857 0 00-.844.869v2.857a.857.857 0 00.251.606L7.108 8.32A.857.857 0 108.32 7.108l-.892-.892v-2.5a.857.857 0 00-.871-.869zm7.054.584a7.633 7.633 0 01.537 1.714h6.137a2 2 0 012 2V8h-8.138a7.692 7.692 0 01-.537 1.714h8.674v10.572a2 2 0 01-2 2H7.143a2 2 0 01-2-2v-6.138a7.692 7.692 0 01-1.714-.537v6.674A3.719 3.719 0 007.143 24h13.143A3.719 3.719 0 0024 20.286V7.143a3.719 3.719 0 00-3.714-3.714zm.1 8.571a1.429 1.429 0 101.429 1.429A1.429 1.429 0 0013.714 12zm4.857 0A1.429 1.429 0 1020 13.429 1.429 1.429 0 0018.571 12zm-9.712 5.143a1.429 1.429 0 101.429 1.429 1.429 1.429 0 00-1.429-1.429zm4.857 0a1.429 1.429 0 101.429 1.429 1.429 1.429 0 00-1.429-1.429z"
            transform="translate(39 341)"
            fill="#eb6d13"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
export function SOSIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    width: 16.57,
    height: 16.184,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 16.57 16.184"
      {...rest}
    >
      <path
        d="M11.276 1.978a.592.592 0 00-.583.6v1.579a.592.592 0 101.184 0V2.579a.592.592 0 00-.6-.6zm-5.718 2.37a.592.592 0 00-.412 1.016l.789.789a.592.592 0 10.837-.837l-.789-.789a.592.592 0 00-.425-.179zm11.83 0a.592.592 0 00-.407.179l-.789.789a.592.592 0 10.837.837l.789-.789a.592.592 0 00-.43-1.016zm-6.979 1.19a4.167 4.167 0 00-4.128 3.8l-.472 5.67h-.245a.988.988 0 00-.986.986v1.184a.988.988 0 00.986.986h11.441a.988.988 0 00.986-.986v-1.186a.988.988 0 00-.986-.986h-.245l-.472-5.67a4.167 4.167 0 00-4.128-3.8zm-.14 1.385a.592.592 0 11.06 1.182 1.583 1.583 0 00-1.491 1.444l-.393 4.906a.591.591 0 01-.59.545h-.048a.591.591 0 01-.542-.637l.393-4.908a2.773 2.773 0 012.611-2.533zM3.592 9.877a.592.592 0 100 1.184h1.183a.592.592 0 100-1.184zm14.2 0a.592.592 0 100 1.184h1.184a.592.592 0 100-1.184z"
        transform="translate(-3 -1.978)"
        fill="#f44f5a"
      />
    </SvgIcon>
  );
}
export function ScheduleIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    width: 44,
    height: 44,
    color: 'primary.main',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 44 44"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 5630" transform="translate(-29 -330)">
        <rect
          data-name="Rectangle 44708"
          width={44}
          height={44}
          rx={6}
          transform="translate(29 330)"
          fill="#fff6f0"
        />
        <path
          d="M6.605 5A2.608 2.608 0 004 7.605v16.79A2.608 2.608 0 006.605 27h2.5a3.753 3.753 0 01-.949-1.737H6.605a.869.869 0 01-.868-.868V7.605a.869.869 0 01.868-.868h1.553A3.758 3.758 0 019.106 5zm5.211 0a2.619 2.619 0 00-2.605 2.605v16.79A2.619 2.619 0 0011.816 27h12.737a2.619 2.619 0 002.605-2.605V12.816a.868.868 0 00-.258-.616l-6.944-6.946A.869.869 0 0019.342 5zm0 1.737h6.658v4.342a2.619 2.619 0 002.605 2.605h4.342v10.711a.855.855 0 01-.868.868H11.816a.855.855 0 01-.868-.868V7.605a.855.855 0 01.868-.868zm8.395 1.228l3.983 3.983h-3.115a.855.855 0 01-.868-.868zm-5.5 8.614a.868.868 0 100 1.737h6.947a.868.868 0 100-1.737zm0 4.053a.868.868 0 100 1.737h5.211a.868.868 0 100-1.737z"
          transform="translate(35.421 336)"
          fill="#eb6d13"
        />
      </g>
    </SvgIcon>
  );
}

export function TestIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    width: 44,
    height: 44,
    color: 'primary.main',
    ...rootStyle,
  };
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 44 44"
    {...rest}
    sx={rootSx}
  >
    <g data-name="Group 5630" transform="translate(-29 -330)">
      <rect
        data-name="Rectangle 44708"
        width={44}
        height={44}
        rx={6}
        transform="translate(29 330)"
        fill="#fff6f0"
      />
      <path
        d="M18.851 5.3a1.448 1.448 0 00-.538.077l-8.225 2.8-3.911.3A2.367 2.367 0 004 10.834v3.257a2.367 2.367 0 002.178 2.351h.049-.573l.383 3.446a1.776 1.776 0 003.54-.2V16.7l.513.039 8.224 2.8a1.518 1.518 0 001.986-1.414v-3.86a1.713 1.713 0 000-3.177V6.8a1.522 1.522 0 00-1.274-1.48 1.467 1.467 0 00-.175-.02zm-.012 1.281a.2.2 0 01.173.218v11.326a.2.2 0 01-.284.2l-8.3-2.83a.643.643 0 00-.158-.033l-1.287-.1a.643.643 0 00-.692.642v3.685a.489.489 0 01-.974.054l-.448-4.013a.643.643 0 00-.592-.57 1.064 1.064 0 01-.99-1.069v-3.257a1.064 1.064 0 01.99-1.069l3.3-.253v4.023a.643.643 0 101.287 0V9.277L18.729 6.6a.259.259 0 01.11-.019z"
        transform="translate(-4 -5.299)"
        fill="#eb6d13"
      />
    </g>
  </SvgIcon>;
}
export function MyFamilyicon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    width: 44,
    height: 44,
    color: '#007965',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 44 44"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 5630" transform="translate(-29 -330)">
        <rect
          data-name="Rectangle 44708"
          width={44}
          height={44}
          rx={6}
          transform="translate(29 330)"
          fill="#fff6f0"
        />
        <path
          data-name="My family"
          d="M12.911 4.5A5.291 5.291 0 1018.2 9.791 5.3 5.3 0 0012.911 4.5zm0 1.671a3.62 3.62 0 11-3.62 3.62 3.608 3.608 0 013.62-3.62zm7.8 5.848a3.317 3.317 0 00-2.5 1.064 3.516 3.516 0 000 4.556 3.479 3.479 0 005.008 0 3.516 3.516 0 000-4.556 3.317 3.317 0 00-2.51-1.064zm0 1.671a1.54 1.54 0 011.255.5 1.85 1.85 0 010 2.337 1.54 1.54 0 01-1.255.5 1.54 1.54 0 01-1.255-.5 1.85 1.85 0 010-2.337 1.54 1.54 0 011.253-.5zm-14.2 3.9A2.509 2.509 0 004 20.095v.668C4 23.98 7.914 26.5 12.911 26.5a13.783 13.783 0 002.961-.319 4.835 4.835 0 01-1.324-1.453 13.17 13.17 0 01-1.637.1c-4.472 0-7.241-2.111-7.241-4.066v-.668a.836.836 0 01.835-.835h9.219a3.592 3.592 0 011.92-.557h.126a4.5 4.5 0 01-.916-1.114zm11.139 2.228a2.519 2.519 0 00-2.506 2.506v.469a3.305 3.305 0 001.7 2.7 7.2 7.2 0 003.873 1 7.2 7.2 0 003.873-1 3.305 3.305 0 001.7-2.7v-.469a2.519 2.519 0 00-2.506-2.506zm0 1.671h6.127a.823.823 0 01.835.835v.469a1.652 1.652 0 01-.925 1.3 5.632 5.632 0 01-2.974.742 5.632 5.632 0 01-2.974-.742 1.652 1.652 0 01-.925-1.3v-.469a.823.823 0 01.832-.837z"
          transform="translate(35.861 336.5)"
          fill="#eb6d13"
        />
      </g>
    </SvgIcon>
  );
}
export function MyCircleIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    width: 44,
    height: 44,
    color: '#007965',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 44 44"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 5630" transform="translate(-29 -330)">
        <rect
          data-name="Rectangle 44708"
          width={44}
          height={44}
          rx={6}
          transform="translate(29 330)"
          fill="#fff6f0"
        />
        <path
          d="M13.862 2a2.069 2.069 0 102.069 2.069A2.069 2.069 0 0013.862 2zm-2.069 5.172a1.563 1.563 0 00-1.552 1.552 3.345 3.345 0 003.621 3.1 3.345 3.345 0 003.621-3.1 1.563 1.563 0 00-1.552-1.552zM8.86 7.7a8.706 8.706 0 00-3.2 4.06c-.1.264-.192.533-.27.8a3.584 3.584 0 011.231-.217 2.783 2.783 0 01.466.036c.005-.021.015-.036.02-.057a7.129 7.129 0 011.707-2.578 4.294 4.294 0 01-.124-1.02A3.2 3.2 0 018.86 7.7zm10 0a3.2 3.2 0 01.171 1.024 4.294 4.294 0 01-.124 1.019 7.116 7.116 0 011.722 2.638 2.843 2.843 0 01.471-.036 3.4 3.4 0 011.22.217A8.764 8.764 0 0018.864 7.7zM6.621 13.9a2.069 2.069 0 102.069 2.066A2.069 2.069 0 006.621 13.9zm14.483 0a2.069 2.069 0 102.069 2.069A2.069 2.069 0 0021.1 13.9zM4.552 19.069A1.563 1.563 0 003 20.621a3.345 3.345 0 003.621 3.1 3.345 3.345 0 003.621-3.1 1.563 1.563 0 00-1.552-1.552zm14.483 0a1.563 1.563 0 00-1.552 1.552 3.345 3.345 0 003.621 3.1 3.345 3.345 0 003.621-3.1 1.563 1.563 0 00-1.552-1.552zM16.1 21.811a7.167 7.167 0 01-4.479.005 4.778 4.778 0 01-.673 1.411 8.723 8.723 0 005.825-.005 4.535 4.535 0 01-.673-1.411z"
          transform="translate(37.138 339.137)"
          fill="#eb6d13"
        />
      </g>
    </SvgIcon>
  );
}
export function HealthCirclesLogo(props) {
  const { rootStyle, organisationName, ...rest } = props;

  const rootSx = {
    color: '#007965',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.319 30.2"
      {...rest}
      sx={rootSx}
    >
      <path
        data-name="Path 1"
        d="M28.4 20.33a11.154 11.154 0 01-14.35 4.881 10.07 10.07 0 001.5.118 10.232 10.232 0 10-2.42-20.143A11.2 11.2 0 0128.4 20.33zM5.02 18.971A14.131 14.131 0 0118.569.847a13.9 13.9 0 012.576.249A14.936 14.936 0 0015.563 0a15.1 15.1 0 104.263 29.581 15.437 15.437 0 002.527-1.007 14.082 14.082 0 01-17.332-9.6zm8.874-9.656v3.714h-3.713v3.9h3.713v3.713h3.9v-3.718H21.5v-3.9h-3.71v-3.71z"
        fill="#007965"
        transform="translate(-.452)"
      />
    </SvgIcon>
  );
}

export function EditIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 14,
    width: 14,
    color: 'rgba(24,68,87,0.72)',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 14 14"
      {...rest}
    >
      <path
        d="M16.425 5.01a2.571 2.571 0 00-1.824.752l-8.157 8.157a1.29 1.29 0 00-.328.559l-1.094 3.828a.553.553 0 00.683.683l3.83-1.089a1.292 1.292 0 00.557-.328l8.157-8.162a2.576 2.576 0 00-1.824-4.4zm0 1.1a1.468 1.468 0 011.042.435 1.465 1.465 0 010 2.084l-.715.715-2.084-2.086.715-.715a1.469 1.469 0 011.042-.434zm-2.539 1.93l2.085 2.085-6.661 6.66a.187.187 0 01-.08.047l-2.872.821.821-2.873a.18.18 0 01.047-.079z"
        transform="translate(-5.001 -5.01)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function MBFIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 24,
    width: 24,
    color: 'primary.main',
    strokeWidth: 0.2,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={22.8}
      height={24}
      viewBox="0 0 22.8 24"
      sx={rootSx}
      {...rest}
    >
      <path
        data-name="Path 4863"
        d="M9 10.189a12.472 12.472 0 01.891-1.184 1.86 1.86 0 00.271-2.012 2.631 2.631 0 00-.337-.633A4.217 4.217 0 0112.364.154 4.488 4.488 0 0113.511.01q3.043-.02 6.084-.01a4.279 4.279 0 014.169 4.97 3.784 3.784 0 01-.528 1.319 2.16 2.16 0 00.12 2.976c.22.294.424.6.654.926a.546.546 0 01-.776-.191 8.742 8.742 0 00-13.423-.036 2.47 2.47 0 01-.679.4L9 10.189zm7.56-7.421c-1.012 0-2.024-.005-3.036 0a1.868 1.868 0 00-.628.1 1.536 1.536 0 00-.927 1.751 1.3 1.3 0 001.317 1.2q3.2.055 6.392.008a1.371 1.371 0 001.413-1.581 1.465 1.465 0 00-1.56-1.476c-.991-.007-1.98 0-2.971 0zM9.72 4.822a4.585 4.585 0 011.1-2.711A18.363 18.363 0 0112.865.435a3.747 3.747 0 00-3.146 4.387z"
        transform="translate(-5.2)"
        fill="currentColor"
      />
      <path
        data-name="Path 4864"
        d="M24.01 46.049A8.667 8.667 0 019 45.917a4.85 4.85 0 013.031.7 8.371 8.371 0 003.035 1.575 6.545 6.545 0 005.859-1.492 2.383 2.383 0 011.75-.686 8.545 8.545 0 001.278-.112l.056.149z"
        transform="translate(-5.2 -26.316)"
        fill="currentColor"
      />
      <path
        data-name="Path 4865"
        d="M22.779 43.269c-.845.077-1.66.16-2.478.223-1.341.1-2.682.192-4.023.28a2.3 2.3 0 00-1.3.481 6.057 6.057 0 01-7.253-.04 2.075 2.075 0 00-.985-.408c-1.922-.17-3.849-.289-5.774-.432-.317-.023-.632-.078-.934-.116-.124-.495.172-.5.47-.5h3.645c1.086 0 2.173-.023 3.257.014a1.771 1.771 0 01.941.312 4.741 4.741 0 006.1-.01 1.583 1.583 0 01.875-.3c2.3-.024 4.6-.015 6.9-.01.278 0 .669-.1.549.509z"
        transform="translate(0 -24.51)"
        fill="currentColor"
      />
      <path
        data-name="Path 4866"
        d="M0 23.6a1.724 1.724 0 01.538-.284c1.009-.11 2.022-.187 3.035-.27 1.142-.093 2.286-.153 3.423-.282a1.97 1.97 0 00.861-.41 5.846 5.846 0 017.067-.028 4.245 4.245 0 002.348.577c1.805.16 3.614.288 5.454.431l.074.494h-1.53c-1.948 0-3.9.025-5.843-.005a1.993 1.993 0 01-1.064-.356 4.727 4.727 0 00-5.944.06 1.518 1.518 0 01-.821.293c-2.423.022-4.848.012-7.271.009a1.5 1.5 0 01-.249-.042L0 23.6z"
        transform="translate(0 -12.126)"
        fill="currentColor"
      />
      <path
        data-name="Path 4867"
        d="M16.206 31v3.84h-.9v-2.3l-.831 2.3h-.73l-.845-2.308v2.308H12V31h1.069l1.042 2.658L15.143 31z"
        transform="translate(-6.933 -17.773)"
        fill="currentColor"
      />
      <path
        data-name="Path 4868"
        d="M27.507 32.871a.856.856 0 01.519.334.949.949 0 01.2.591.962.962 0 01-.328.766 1.34 1.34 0 01-.9.279h-1.73V31h1.662a1.329 1.329 0 01.884.268.988.988 0 01.148 1.291.874.874 0 01-.455.312zm-1.344-.317h.593a.511.511 0 00.339-.1.433.433 0 000-.6.493.493 0 00-.339-.1h-.593zm.667 1.532a.523.523 0 00.349-.1.389.389 0 00.127-.312.4.4 0 00-.132-.317.509.509 0 00-.354-.115h-.656v.848z"
        transform="translate(-14.594 -17.773)"
        fill="currentColor"
      />
      <path
        data-name="Path 4869"
        d="M37.691 31v.749h-1.513v.81h1.132v.728h-1.132v1.553h-.9V31z"
        transform="translate(-20.38 -17.773)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function UserNameIcon(props) {
  const { rootStyle, letter, ...rest } = props;

  const rootSx = {
    height: 24,
    width: 24,
    borderRadius: '100%',
    display: 'grid',
    placeItems: 'center',
    ...rootStyle,
  };
  return (
    <Box sx={rootSx} {...rest}>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {letter}
      </Typography>
    </Box>
  );
}

export function SuitCaseIcon(props) {
  const { rootStyle, letter, ...rest } = props;

  const rootSx = {
    height: 16,
    width: 16,
    borderRadius: '100%',
    display: 'grid',
    placeItems: 'center',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 102673" transform="translate(-12925 -11524)">
        <circle
          data-name="Ellipse 129459"
          cx={8}
          cy={8}
          r={8}
          transform="translate(12925 11524)"
          fill="#fff"
        />
        <path
          d="M5.688 2a1.563 1.563 0 00-1.563 1.563H2.563A1.563 1.563 0 001 5.125v5.73a1.563 1.563 0 001.563 1.563H10.9a1.563 1.563 0 001.563-1.563v-5.73A1.563 1.563 0 0010.9 3.563H9.334A1.563 1.563 0 007.772 2zm0 1.042h2.084a.521.521 0 01.521.521H5.167a.521.521 0 01.521-.521zm.521 4.167h1.042v1.428l4.167-1.249v3.467a.521.521 0 01-.521.521H2.563a.521.521 0 01-.521-.521V7.388l4.167 1.249zm0 1.428v.655h1.042v-.655l-.371.112a.519.519 0 01-.3 0z"
          transform="translate(12926.27 11525.582)"
        />
      </g>
    </SvgIcon>
  );
}
export function UploadIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    width: 76.288,
    height: 59.846,
    ...rootStyle,
  };

  return (
    <SvgIcon
      data-name="Group 4627"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 76.288 59.846"
      {...rest}
      sx={rootSx}
    >
      <path
        data-name="Path 602"
        d="M56.156 37.339a10.479 10.479 0 110 20.958H19.479a10.479 10.479 0 010-20.958H22.1v-2.62a15.719 15.719 0 0131.437 0v2.62z"
        transform="translate(.326 -7)"
        fill="rgba(0,121,101,0.16)"
      />
      <path
        data-name="Path 603"
        d="M67.162 69.27h-6.577a1.973 1.973 0 110-3.946h6.577a11.18 11.18 0 000-22.36h-3.289a1.938 1.938 0 01-1.973-1.973V37.7a17.757 17.757 0 10-35.513 0v3.288a1.938 1.938 0 01-1.973 1.973h-3.288a11.18 11.18 0 100 22.36H27.7a1.973 1.973 0 010 3.946h-6.574a15.126 15.126 0 010-30.252h1.315V37.7a21.7 21.7 0 1143.405 0v1.315h1.315a15.126 15.126 0 010 30.252z"
        transform="translate(-6 -16)"
        fill="#444b54"
      />
      <path
        data-name="Path 604"
        d="M62.973 94.675A1.938 1.938 0 0161 92.7V72.973a1.973 1.973 0 113.946 0V92.7a1.938 1.938 0 01-1.973 1.975z"
        transform="translate(-24.829 -34.829)"
        fill="#464c55"
      />
      <path
        data-name="Path 605"
        d="M66.126 81.522a1.893 1.893 0 01-1.381-.592l-5.2-5.2-5.2 5.2a1.953 1.953 0 01-2.762-2.762l6.577-6.577a1.907 1.907 0 012.762 0l6.577 6.577a1.973 1.973 0 01-1.381 3.354z"
        transform="translate(-21.406 -34.829)"
        fill="#464c55"
      />
    </SvgIcon>
  );
}
export function PressureNoBgIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 16.6,
    width: 16.6,
    color: 'rgba(24,87,76,0.48)',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.6 16.6"
      {...rest}
      sx={rootSx}
    >
      <g transform="translate(.3 .3)">
        <path data-name="Rectangle 44627" fill="none" d="M0 0H16V16H0z" />
        <g data-name="Path 4862" fill="currentColor">
          <path
            d="M10.394 2a2 2 0 00-2 2v6.4a2 2 0 002 2h1.6v2.8a2 2 0 01-2 2H6.8a2 2 0 01-2-2v-2A3.023 3.023 0 007.6 10a3.281 3.281 0 00-1.522-2.844l.316-1.891A.4.4 0 006 4.8H3.6a.4.4 0 00-.394.466l.316 1.891A3.281 3.281 0 002 10a3.178 3.178 0 002 3.065V15.2A2.8 2.8 0 006.8 18H10a2.8 2.8 0 002.8-2.8v-2.8h1.474a2.4 2.4 0 102.122-4.26V4a2 2 0 00-2-2zm0 .8h4a1.2 1.2 0 011.2 1.2v4a2.4 2.4 0 00-2.073 3.6h-3.127a1.2 1.2 0 01-1.2-1.2V4a1.2 1.2 0 011.2-1.2zM4.073 5.6h1.453l-.21 1.257a2.362 2.362 0 00-1.033 0zm.727 2a2.229 2.229 0 012 2.4 2.229 2.229 0 01-2 2.4 2.229 2.229 0 01-2-2.4 2.229 2.229 0 012-2.4zm10.77 1.2h.02a1.566 1.566 0 11-.02 0zm.008.4a.4.4 0 00-.388.4v1.2a.4.4 0 00.4.4h.8a.4.4 0 000-.8h-.4v-.8a.4.4 0 00-.411-.4z"
            transform="translate(-2 -2)"
          />
          <path
            d="M10.394 2a2 2 0 00-1.998 2v6.4a2.004 2.004 0 001.998 2h1.598v2.8a2.004 2.004 0 01-1.998 2H6.797a2 2 0 01-1.998-2v-2c1.543 0 2.798-1.436 2.798-3.2a3.283 3.283 0 00-1.52-2.844l.317-1.89a.4.4 0 00-.396-.466H3.6a.4.4 0 00-.394.466l.316 1.89A3.279 3.279 0 002.002 10 3.18 3.18 0 004 13.065V15.2A2.805 2.805 0 006.797 18h3.197a2.8 2.8 0 002.798-2.8v-2.8h1.474a2.396 2.396 0 003.732-1.902 2.404 2.404 0 00-1.61-2.358V4a2.003 2.003 0 00-1.998-2h-3.996m5.195 6a2.394 2.394 0 00-2.073 3.6h-3.122a1.198 1.198 0 01-1.199-1.2V4a1.2 1.2 0 011.199-1.2h3.996A1.198 1.198 0 0115.59 4v4M4.073 5.6h1.453l-.21 1.257a2.362 2.362 0 00-1.033 0L4.073 5.6m.726 6.8c-1.101 0-1.998-1.076-1.998-2.4 0-1.324.897-2.4 1.998-2.4 1.102 0 1.998 1.076 1.998 2.4 0 1.324-.896 2.4-1.998 2.4m10.79-.4a1.597 1.597 0 01-1.565-1.276A1.601 1.601 0 0115.57 8.8h.019a1.598 1.598 0 011.599 1.6 1.602 1.602 0 01-1.599 1.6m0-2.8a.4.4 0 00-.4.4v1.2a.4.4 0 00.4.4h.8a.4.4 0 000-.8h-.4v-.8a.401.401 0 00-.4-.4m-5.195-7.5h3.996c.614 0 1.19.24 1.625.674.433.435.672 1.012.673 1.626v3.935c.285.125.543.297.77.513.28.266.497.582.642.94a2.684 2.684 0 01-.084 2.224 2.683 2.683 0 01-.71.889 2.707 2.707 0 01-3.128.2l-1.086-.001v2.5c-.001.828-.324 1.606-.908 2.191a3.08 3.08 0 01-2.19.909H6.798a3.08 3.08 0 01-2.189-.909 3.084 3.084 0 01-.908-2.19v-1.94a3.455 3.455 0 01-1.435-1.248 3.462 3.462 0 01-.563-2.015 3.59 3.59 0 011.493-2.982l-.285-1.7a.705.705 0 01.157-.568A.705.705 0 013.6 4.5h2.398a.706.706 0 01.535.247.705.705 0 01.157.568l-.285 1.7a3.587 3.587 0 011.492 2.988c-.002 1.814-1.231 3.31-2.798 3.48V15.2c0 .454.178.88.498 1.201.321.321.747.498 1.2.499h3.197c.453 0 .88-.178 1.2-.499.321-.32.498-.747.498-1.201v-2.5h-1.298c-.614 0-1.19-.24-1.624-.674a2.289 2.289 0 01-.674-1.626V4c0-.614.24-1.191.674-1.626a2.285 2.285 0 011.624-.674zm4.895 6.016V4a.895.895 0 00-.263-.637.893.893 0 00-.636-.263h-3.996a.893.893 0 00-.636.264.895.895 0 00-.263.636v6.4c0 .24.094.467.263.637.17.17.396.263.636.263h2.654a2.702 2.702 0 01.203-2.25 2.697 2.697 0 012.038-1.334zM5.172 5.9h-.745l.102.614c.18-.019.36-.019.54 0l.103-.614zm-.373 6.2c.937 0 1.698-.942 1.698-2.1 0-1.158-.761-2.1-1.698-2.1-.936 0-1.698.942-1.698 2.1 0 1.158.762 2.1 1.698 2.1zm12.085-1.794a1.29 1.29 0 00-.69-1.057.704.704 0 01.095.351v.5h.1c.183 0 .364.075.494.205l.001.001zm-.603 1.194h-.692a.696.696 0 01-.7-.7V9.6c0-.124.033-.244.094-.35a1.31 1.31 0 00-.598.663 1.297 1.297 0 00.292 1.412 1.294 1.294 0 001.604.175z"
            transform="translate(-2 -2)"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
